import React from 'react';
import { AMAZON_ASSOCIATE_LINE, AMAZON_GLOBAL_DISCLOSURE, AMAZON_STORE_DISCLOSURE } from './amazonAffiliate';
import { LAST_UPDATED_DATE } from './legalPlaceholders';

const AffiliateDisclosurePage = () => (
  <main className="legal-page">
    <h1>Affiliate Disclosure</h1>
    <p>
      <strong>Last updated:</strong> {LAST_UPDATED_DATE}
    </p>
    <p>
      <strong>{AMAZON_ASSOCIATE_LINE}</strong> {AMAZON_GLOBAL_DISCLOSURE}
    </p>
    <p>{AMAZON_STORE_DISCLOSURE}</p>
    <p>
      Unless we explicitly say otherwise, product tags and gear links are discovery tools, not guarantees of a verified
      exact product match.
    </p>
    <p>
      When a setup tag opens Amazon, it may lead to search results or similar products rather than a specific product
      page.
    </p>
    <p>We aim to keep commercial disclosures clear in our footer and legal pages without interrupting the editorial experience.</p>
  </main>
);

export default AffiliateDisclosurePage;
